import React, { useState, useEffect, useRef } from 'react';
import { ServiciosScreen } from './ServiciosScreen';
import { ColaboradorasScreen } from './ColaboradorasScreen';
import { PagosScreen } from './PagosScreen';
import { MiNegocioScreen } from './MiNegocioScreen';
import { useSelector, useDispatch } from 'react-redux';
import { esMexico } from '../../helpers/util';
import { startLogout } from '../../actions/auth';
import Swal from 'sweetalert2';

const WA_NUMERO = process.env.REACT_APP_WA_NUMERO_COMPARTIDO || '527714709601';
const REVI_STRIPE_API = process.env.REACT_APP_STRIPE_API_URL || 'https://revi-stripe-service-717967703066.us-central1.run.app';

export const HomeScreen = () => {
    const dispatch = useDispatch();
    const { nombre, hashtag, displayName, zonaHoraria } = useSelector(state => state.auth);
    const [tab, setTab] = useState('inicio');
    const [toast, setToast] = useState(false);
    const [cancelando, setCancelando] = useState(false);
    const qrRef = useRef(null);
    const qrGenRef = useRef(null);

    const nombreCorto = (displayName || nombre || '').split(' ')[0];
    const esMex = esMexico(zonaHoraria);
    const hashtagLimpio = hashtag ? hashtag.replace('#', '') : '';
    const msg = encodeURIComponent(`Quiero reservar con ${hashtag}`);
    const link = `https://wa.me/${WA_NUMERO}?text=${msg}`;
    const linkMostrar = `wa.me/${WA_NUMERO}?text=Quiero reservar con ${hashtag}`;

    useEffect(() => {
        if (tab === 'link' && qrRef.current && !qrGenRef.current) {
            const script = document.createElement('script');
            script.src = 'https://cdnjs.cloudflare.com/ajax/libs/qrcodejs/1.0.0/qrcode.min.js';
            script.onload = () => {
                try {
                    qrGenRef.current = new window.QRCode(qrRef.current, {
                        text: link,
                        width: 150,
                        height: 150,
                        colorDark: '#72243E',
                        colorLight: '#ffffff',
                        correctLevel: window.QRCode.CorrectLevel.M,
                    });
                } catch (e) {}
            };
            document.head.appendChild(script);
        }
    }, [tab, link]);

    const copiarLink = () => {
        if (navigator.clipboard) navigator.clipboard.writeText(link).catch(() => {});
        setToast(true);
        setTimeout(() => setToast(false), 2500);
    };

    const compartirLink = () => {
        if (navigator.share) {
            navigator.share({ title: `Reserva en ${nombre}`, text: 'Reserva tu cita aquí:', url: link });
        } else {
            copiarLink();
        }
    };

    const descargarQR = () => {
        const canvas = qrRef.current?.querySelector('canvas');
        if (!canvas) return;
        const a = document.createElement('a');
        a.download = `mi-link-${hashtagLimpio}.png`;
        a.href = canvas.toDataURL();
        a.click();
    };

    const handleCancelarSuscripcion = async () => {
        const result = await Swal.fire({
            title: '¿Cancelar suscripción?',
            text: 'Si cancelas durante el periodo de prueba perderás acceso de inmediato. Si ya pagaste, tendrás acceso hasta el fin del periodo.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, cancelar',
            cancelButtonText: 'No, mantener',
            confirmButtonColor: '#CE4979',
            cancelButtonColor: '#aaa',
        });

        if (!result.isConfirmed) return;

        setCancelando(true);
        try {
            const res = await fetch(`${REVI_STRIPE_API}/stripe/cancelar`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(hashtag)
            });

            const data = await res.json();
            if (!res.ok) throw new Error(data.error || 'Error al cancelar');

            Swal.fire({
                title: 'Suscripción cancelada',
                text: 'Tu suscripción ha sido cancelada exitosamente.',
                icon: 'success',
                confirmButtonColor: '#CE4979',
            }).then(() => {
                dispatch(startLogout());
            });

        } catch (e) {
            Swal.fire('Error', e.message || 'No se pudo cancelar la suscripción', 'error');
        } finally {
            setCancelando(false);
        }
    };

    return (
        <div className="app-container">
            <div className="app-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                    <h1>Hola, {nombreCorto} 👋</h1>
                    <p>{nombre}</p>
                </div>
                <button onClick={() => dispatch(startLogout())}
                    style={{ color: 'var(--pink-800)', background: 'none', border: 'none', fontSize: 13, cursor: 'pointer' }}>
                    Salir
                </button>
            </div>

            <div className="tab-nav">
                <div className={`tab-item ${tab === 'inicio' ? 'active' : ''}`} onClick={() => setTab('inicio')}>Inicio</div>
                <div className={`tab-item ${tab === 'servicios' ? 'active' : ''}`} onClick={() => setTab('servicios')}>Servicios</div>
                <div className={`tab-item ${tab === 'link' ? 'active' : ''}`} onClick={() => setTab('link')}>Mi link</div>
                <div className={`tab-item ${tab === 'quien' ? 'active' : ''}`} onClick={() => setTab('quien')}>¿Quién atiende?</div>
            </div>

            {tab === 'inicio' && (
                <div className="screen-body">
                    <div className="home-card" onClick={() => setTab('link')}
                        style={{ border: '2px solid var(--pink-600)', marginBottom: 10 }}>
                        <div className="home-card-icon">🔗</div>
                        <div style={{ flex: 1 }}>
                            <div className="home-card-title">Mi link de reservas</div>
                            <div className="home-card-sub">Compártelo con tus clientas</div>
                        </div>
                        <div className="arrow-right">›</div>
                    </div>
                    <div className="home-card" onClick={() => setTab('negocio')}>
                        <div className="home-card-icon">📍</div>
                        <div style={{ flex: 1 }}>
                            <div className="home-card-title">Mi negocio</div>
                            <div className="home-card-sub">Dirección, teléfono, tolerancia</div>
                        </div>
                        <div className="arrow-right">›</div>
                    </div>
                    <div className="home-card" onClick={() => setTab('servicios')}>
                        <div className="home-card-icon">✂️</div>
                        <div style={{ flex: 1 }}>
                            <div className="home-card-title">Servicios y precios</div>
                            <div className="home-card-sub">Edita tus servicios</div>
                        </div>
                        <div className="arrow-right">›</div>
                    </div>
                    <div className="home-card" onClick={() => setTab('quien')}>
                        <div className="home-card-icon">👩</div>
                        <div style={{ flex: 1 }}>
                            <div className="home-card-title">¿Quién atiende?</div>
                            <div className="home-card-sub">Colaboradoras y horarios</div>
                        </div>
                        <div className="arrow-right">›</div>
                    </div>
                    {esMex && (
                        <div className="home-card" onClick={() => setTab('pagos')}>
                            <div className="home-card-icon">💳</div>
                            <div style={{ flex: 1 }}>
                                <div className="home-card-title">Pagos y anticipos</div>
                                <div className="home-card-sub">Datos para recibir pagos</div>
                            </div>
                            <div className="arrow-right">›</div>
                        </div>
                    )}

                    <button
                        onClick={handleCancelarSuscripcion}
                        disabled={cancelando}
                        style={{
                            width: '100%',
                            marginTop: 24,
                            padding: '12px',
                            background: 'none',
                            border: '0.5px solid #ccc',
                            borderRadius: 10,
                            color: '#999',
                            fontSize: 13,
                            cursor: 'pointer'
                        }}
                    >
                        {cancelando ? 'Cancelando...' : 'Cancelar suscripción'}
                    </button>
                </div>
            )}

            {tab === 'link' && (
                <div className="screen-body">
                    <div style={{ background: 'var(--pink-50)', border: '0.5px solid var(--border)', borderRadius: 12, padding: 16, marginBottom: 12 }}>
                        <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--pink-900)', marginBottom: 8 }}>🔗 Tu link de reservas</div>
                        <p style={{ fontSize: 12, color: 'var(--pink-800)', marginBottom: 10, lineHeight: 1.6 }}>
                            Comparte este link en tus redes sociales, WhatsApp o imprime el código QR. Tus clientas solo hacen clic y pueden reservar contigo.
                        </p>
                        <div className="link-box">
                            <div className="link-text">{linkMostrar}</div>
                            <button className="copy-btn" onClick={copiarLink}>Copiar</button>
                        </div>
                        <div className="action-grid">
                            <div className="action-btn" onClick={compartirLink}>📤 Compartir</div>
                            <a href={link} target="_blank" rel="noreferrer" style={{ textDecoration: 'none' }}>
                                <div className="action-btn">👁️ Probarlo</div>
                            </a>
                        </div>
                    </div>

                    <div style={{ background: 'var(--pink-50)', border: '0.5px solid var(--border)', borderRadius: 12, padding: 16, marginBottom: 12 }}>
                        <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--pink-900)', marginBottom: 8 }}>📱 Código QR</div>
                        <p style={{ fontSize: 12, color: 'var(--pink-800)', marginBottom: 10 }}>
                            Imprímelo en tus tarjetas de presentación o ponlo en tu negocio.
                        </p>
                        <div style={{ display: 'flex', justifyContent: 'center', margin: '12px 0' }}>
                            <div ref={qrRef} style={{ background: '#fff', padding: 8, borderRadius: 10, border: '0.5px solid var(--border)' }} />
                        </div>
                        <div className="action-grid">
                            <div className="action-btn" onClick={descargarQR}>💾 Descargar</div>
                            <div className="action-btn" onClick={compartirLink}>📤 Compartir</div>
                        </div>
                    </div>

                    <div className="info-box">
                        <div className="info-box-title">💡 ¿Cómo funciona?</div>
                        <div className="info-box-body">
                            1. Tu clienta hace clic en el link o escanea el QR<br />
                            2. Se abre WhatsApp con el mensaje listo<br />
                            3. Solo presiona enviar y el bot la atiende<br />
                            4. ¡Cita reservada sin que tú hagas nada!
                        </div>
                    </div>
                </div>
            )}

            {tab === 'negocio' && (
                <MiNegocioScreen onBack={() => setTab('inicio')} />
            )}

            {tab === 'servicios' && (
                <ServiciosScreen onBack={() => setTab('inicio')} />
            )}

            {tab === 'quien' && (
                <ColaboradorasScreen onBack={() => setTab('inicio')} />
            )}

            {tab === 'pagos' && esMex && (
                <PagosScreen onBack={() => setTab('inicio')} />
            )}

            {toast && (
                <div className="toast visible">¡Link copiado!</div>
            )}
        </div>
    );
};
